const infoPanelMobileButtons = document.querySelectorAll('[data-info-panel-mobile-toggle]')

Array.prototype.forEach.call(infoPanelMobileButtons, infoPanelButton => {
  const id = infoPanelButton.getAttribute(['data-info-panel-mobile-toggle'])
  const content = document.querySelector(`[data-info-panel-mobile-content="${id}"]`)
  content.classList.add('is-hidden')
  infoPanelButton.setAttribute('aria-expanded', 'false')

  infoPanelButton.addEventListener('click', () => {
    content.classList.toggle('is-hidden')

    if(infoPanelButton.getAttribute('aria-expanded') === 'true') {
      infoPanelButton.setAttribute('aria-expanded', 'false')
    } else {
      infoPanelButton.setAttribute('aria-expanded', 'true')
    }
  })
})
